/**
 * API origin for RTK Query.
 *
 * Prefer splitting host and port so the port can change per environment without editing the full URL:
 *   REACT_APP_API_BASE_URL=http://localhost
 *   REACT_APP_API_PORT=10605
 *   → http://localhost:10605
 *
 * HTTPS hosts without a custom port (e.g. devservice):
 *   REACT_APP_API_BASE_URL=https://devservice.hgaccountingsystem.com
 *   REACT_APP_API_PORT=
 *   → https://devservice.hgaccountingsystem.com
 *
 * Also accepts a trailing colon on the base (http://localhost:) or a port value starting with : (:10605).
 *
 * If `REACT_APP_API_PORT` is empty, `REACT_APP_API_BASE_URL` is used as the full origin.
 *
 * Legacy: `REACT_APP_LOGIN_PORT` is read if `REACT_APP_API_PORT` is unset.
 *
 * In development, if nothing valid resolves, falls back to http://localhost:10605.
 */
const DEV_DEFAULT_ORIGIN = "http://localhost:10605";

/** Port 8091 is no longer used; strip it from base URLs and ignore it in env. */
const DEPRECATED_API_PORT = "8091";

function stripDeprecatedPortFromBase(base) {
  return base.replace(/:8091(?=\/|$)/i, "");
}

function joinBaseAndPort(base, port) {
  const b = stripDeprecatedPortFromBase(base.replace(/\/+$/, ""));
  if (!port) return b;

  const p = port.startsWith(":") ? port.slice(1) : port;
  if (!p) return b;

  if (b.endsWith(":")) {
    return `${b}${p}`;
  }
  return `${b}:${p}`;
}

export function getApiOrigin() {
  const rawBase = (process.env.REACT_APP_API_BASE_URL ?? "").trim();
  const portRaw = (
    process.env.REACT_APP_API_PORT ??
    process.env.REACT_APP_LOGIN_PORT ??
    ""
  ).trim();
  const port = portRaw === DEPRECATED_API_PORT ? "" : portRaw;

  const combined = joinBaseAndPort(rawBase, port);
  const normalized = stripDeprecatedPortFromBase(combined.replace(/\/+$/, ""));

  if (normalized) {
    return normalized;
  }

  if (process.env.NODE_ENV === "development") {
    return DEV_DEFAULT_ORIGIN;
  }

  return "/";
}
